// extracted by mini-css-extract-plugin
export default {"modalRoot":"iKB_Xn","modalRootCollapsed":"Qz6VHa","container":"arnH_9","centered":"swR2cq","content":"XlwTyi","fromBottom":"QYYd81","fromRight":"gDUNxQ"};